import { Injectable } from '@angular/core';

import { LzUserMessagesService } from "../../modules/lz-user-messages/services/lz-user-messages.service";
import { LzMessageService } from "../../modules/lz-message/services/lz-message.service";
import { CustomRequestService } from "../../services/custom-request/custom-request.service";
import { LzSeoService } from "../../services/seo/seo";

declare var Stomp: any;
declare var SockJS: any;

@Injectable()
export class LzSocketService {

  constructor(private lzUserMessagesService: LzUserMessagesService,
    private lzMessageService: LzMessageService,
    private customRequestService: CustomRequestService,
    private lzSeoService: LzSeoService) {}

  private SOCKET_URL = '/pushnotification/ws';

  private USER_CHANNELS_SUBSCRIPTION: any = [{
      descrption: "ÐÐ¾Ð´Ð¿Ð¸ÑÐºÐ° Ð½Ð° Ð²ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ ÐºÐ¾Ð¼Ð¼Ð°Ð½Ð´ ÐºÐ¾Ð½ÐºÑÐµÑÐ½Ð¾ Ð·Ð°Ð»Ð¾Ð³Ð¸Ð½ÐµÐ½Ð¾Ð³Ð¾ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ",
      url: '/user/notification/command',
      callback: msg => {
        console.log('/user/notification/command', msg);

        let data;

        try {
          data = JSON.parse(msg.body);
        } catch (e) {
          data = {};
        }

        if (data.type == 'execCommand' && this.messageFn[data.name]) {
          this.messageFn[data.name](data);
        }

        if (data.type && this.messageFn[data.type]) {
          this.messageFn[data.type](data);
        }

        this.reloadMessagesCount();
      }
    },
    {
      descrption: "ÐÐ¾Ð´Ð¿Ð¸ÑÐºÐ° Ð½Ð° ÑÐ»ÑÑÐ°Ð½Ð¸Ðµ ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ð¹ ÐºÐ¾Ð½ÐºÑÐµÑÐ½Ð¾ Ð·Ð°Ð»Ð¾Ð³Ð¸Ð½ÐµÐ½Ð¾Ð³Ð¾ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ",
      url: '/user/notification/income',
      callback: msg => {
        console.log('/user/notification/income', msg);

        this.reloadMessagesList();
        this.reloadMessagesCount();

        let data;

        try {
          data = JSON.parse(msg.body);
        } catch (e) {
          data = {};
        }

        if (data.contentType == 'HTML' && data.type == 'MODAL') {
          this.lzMessageService.openMessageHtmlDialog(data.text, data);
        }
      }
    },
    {
      descrption: "ÐÐ¾Ð´Ð¿Ð¸ÑÐºÐ° Ð½Ð° ÑÐ»ÑÑÐ°Ð½Ð¸Ðµ ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ð¹ Ð²Ð¸Ð´Ð¸Ð¼ÑÑ Ð²ÑÐµÐ¼ Ð·Ð°Ð»Ð¾Ð³Ð¸Ð½ÐµÐ½Ð¼ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÐ¼",
      url: ' /notification/general',
      callback: msg => {
        console.log('/notification/general');

        this.reloadMessagesList();
        this.reloadMessagesCount();

        let data;

        try {
          data = JSON.parse(msg.body);
        } catch (e) {
          data = {};
        }

        if (data.contentType == 'HTML') {
          this.lzMessageService.openMessageHtmlDialog(data.text, data);
        }
      }
    }
  ];

  private stompClient: any = null;

  private messageFn = {
    saveUrls: data => {
      this.savePageToSession({
        url: location.href,
        folderId: data.data,
        name: this.lzSeoService.getInfo().title
      });
    },
    execCommand: data => {
      this.lzMessageService.closeMessage(data);
    }
  };

  private savePageToSession = (data: any) => {
    this.customRequestService.postRequest('service/sessions/saveUrl', data).toPromise().then(msg => {

    });
  }

  private reloadMessagesList = () => {
    this.lzUserMessagesService.updateUserMessages('update');
  }

  private reloadMessagesCount = () => {
    this.lzUserMessagesService.updateUserMessagesCount();
  }

  private onMessage = event => {
    let data = JSON.parse(event.data);

    if (data.type == 'execCommand' && this.messageFn[data.name]) {
      this.messageFn[data.name](data);
    }

    if (data.type && this.messageFn[data.type]) {
      this.messageFn[data.type](data);
    }

    this.lzUserMessagesService.updateUserMessagesCount();
  }

  public connect = () => {
    let socket = new SockJS(this.SOCKET_URL);
    let _transportClose = socket._transportClose;
    socket._transportClose = function(code, reason) {
      if (this._transport && this._transport.close) {
        this._transport.close();
      }
      _transportClose.call(this, code, reason);
    };
    this.stompClient = Stomp.over(socket);
    this.stompClient.debug = null;
    this.stompClient.connect({}, frame => {
      for (let channelIndex in this.USER_CHANNELS_SUBSCRIPTION) {
        this.stompClient.subscribe(
          this.USER_CHANNELS_SUBSCRIPTION[channelIndex].url,
          this.USER_CHANNELS_SUBSCRIPTION[channelIndex].callback
        );
      }
    });
  }
}
